export type SchemaFallbackTelemetryInput = {
  objectName: string;
  flow: string;
  actorRole: "leader" | "coach" | "system";
  route?: string;
  errorCode?: string | null;
  degradedMode: string;
  details?: Record<string, unknown>;
};

export function emitSchemaFallbackTelemetry(input: SchemaFallbackTelemetryInput) {
  const payload = {
    event: "schema_missing_fallback",
    object_name: input.objectName,
    flow: input.flow,
    actor_role: input.actorRole,
    route: input.route || null,
    error_code: input.errorCode || null,
    degraded_mode: input.degradedMode,
    environment: typeof window === "undefined" ? "server" : (window.location.hostname || "browser"),
    details: input.details || null,
    ts: new Date().toISOString(),
  };

  console.warn("[schema-fallback]", payload);

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("schema_missing_fallback", {
        detail: payload,
      })
    );
  }
}
